export default __webpack_public_path__ + "static/media/icon_bookmark_24_Regular.81a1e843.svg";